<template>
    <LFeatureGroup>
        <UserMarker
            v-if="positionTrackingEnabled && lastUserPosition"
            :lat="lastUserPosition.lat"
            :lng="lastUserPosition.lng"
        />

        <NavigationRoute v-if="navigationRoute" :waypoints="navigationRoute" />

        <LMarker
            v-if="addressCoordinates"
            :lat-lng="addressCoordinates"
            :icon="pin"
        />
    </LFeatureGroup>
</template>

<script>
import { mapState } from 'vuex'
import { LFeatureGroup, LMarker } from 'vue2-leaflet'

import NavigationRoute from './NavigationRoute'
import UserMarker from './UserMarker'
import { icon } from 'leaflet'

const PIN_ICON = require('@/assets/icons/pin.svg')
const ICON_SIZE = 30
const pin = icon({
    iconUrl: PIN_ICON,
    iconSize: [ICON_SIZE, ICON_SIZE],
    iconAnchor: [ICON_SIZE / 2, ICON_SIZE],
})

export default {
    name: 'UserLayer',
    components: {
        LFeatureGroup,
        LMarker,
        NavigationRoute,
        UserMarker,
    },
    props: {
        userLocation: {
            type: Object,
            default: null,
            validator: v => !isNaN(v.lat) && !isNaN(v.lng),
        },
    },
    data: () => ({ pin }),
    computed: {
        ...mapState('map', [
            'positionTrackingEnabled',
            'lastUserPosition',
            'navigationRoute',
            'addressCoordinates',
        ]),
    },
}
</script>
